// Initial State Object Definition.
export default {
	products: { data: [] },
	centres: { data: [] },
	suppliers: { data: [] },
	productCategories: { data: [] },

	currentCentre: null,
}